import { Fragment } from 'react'

import classNames from 'classnames'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTriangleExclamation,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog, Transition } from '@headlessui/react'

import styles from './index.module.css'

library.add(faTriangleExclamation, faXmark)

const Modal = ({ onConfirm, onClose }) => (
  <Transition.Root show={true} as={Fragment}>
    <Dialog as="div" className="relative z-10" onClose={onClose}>
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </Transition.Child>

      <div className="fixed z-10 inset-0 overflow-y-auto">
        <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <Dialog.Panel
              className={classNames(
                styles.dialogPanel,
                'transform transition-all'
              )}
            >
              <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                <button
                  type="button"
                  className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
                  onClick={onClose}
                >
                  <span className="sr-only">Close</span>
                  <FontAwesomeIcon
                    icon={['fas', 'xmark']}
                    className="h-6 w-6"
                    aria-hidden="true"
                  />
                </button>
              </div>
              <div className="sm:flex sm:items-start">
                <div className={styles.iconcontainer}>
                  <FontAwesomeIcon
                    className="h-6 w-6 text-red-600"
                    aria-hidden="true"
                    icon={['fas', 'triangle-exclamation']}
                  />
                </div>
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <Dialog.Title as="h3" className={styles.title}>
                    Conferma annullamento
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Sicuro di voler annullare l&apos;evento? Premi su
                      &quot;S&igrave;&quot; per annullare l&apos;evento,
                      altrimenti premi su &quot;No&quot; per tornare alla
                      schermata precedente.
                    </p>
                  </div>
                </div>
              </div>
              <div className={styles.buttons}>
                <button
                  type="button"
                  className={styles.buttonYes}
                  onClick={onConfirm}
                >
                  S&igrave;
                </button>
                <button
                  type="button"
                  className={styles.buttonNo}
                  onClick={onClose}
                >
                  No
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition.Root>
)

export default Modal
